<template>
  <div class="carousel-wrapper">
    <swiper :ref="reference" :options="options" dir="rtl">
      <swiper-slide v-for="photo in photos" :key="photo.id">
        <bg-image :src="photo.high" :placeholder="photo.low">
          <div class="ar-75"></div>
        </bg-image>
      </swiper-slide>
    </swiper>

    <div class="navigation">
      <button type="button" class="button-prev" @click="prevSlide">
        <i class="icon-arrow-left"></i>
      </button>
      <button type="button" class="button-next" @click="nextSlide">
        <i class="icon-arrow-right"></i>
      </button>
    </div>
  </div>
</template>

<script>
  import {
    Swiper,
    SwiperSlide
  } from 'vue-awesome-swiper'


  export default {
    components: {
      Swiper,
      SwiperSlide
    },
    props: {
      reference: {
        type: String,
        required: false,
        default: null
      },
      photos: {
        type: Array,
        required: true,
        default: []
      }
    },
    data() {
      return {
        options: {
          slidesPerView: 1.5,
          spaceBetween: 3,
          navigation: {
            nextEl: '.button-next',
            prevEl: '.button-prev'
          },
          breakpoints: {
            576: {
              slidesPerView: 2.5,
            },
            992: {
              slidesPerView: 3.5,
            },
          }
        }
      }
    },
    methods: {
      nextSlide() {
        this.$refs[this.reference].$swiper.slideNext()
      },
      prevSlide() {
        this.$refs[this.reference].$swiper.slidePrev()
      },
    },
  }
</script>

<style scoped lang="scss">
  .carousel-wrapper {
    position: relative;
    background: rgba(#c4dee7, .5);
    padding: 10px 80px 10px 0px;

    .navigation {
      position: absolute;
      bottom: 15px;
      right: 7px;

      button {
        i {
          &::before {
            color: #fff;
            font-size: 1.5rem;
          }
        }

        &.button-prev {
          margin-right: 20px;
        }
      }
    }
  }
</style>